if (!customElements.get('sd-product-assist')) {
  customElements.define('sd-product-assist', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.root = this.closest('.sunshine-pdp');
      this.form = this.root?.querySelector('[data-product-form]');
      this.mainButton = this.root?.querySelector('[data-add-button]');
      this.bar = this.querySelector('[data-assist-bar]');
      this.button = this.querySelector('[data-assist-buy]');
      if (!this.form) return;
      this.root.addEventListener('sd:variant-change', event => this.update(event.detail.variant), {signal:this.abort.signal});
      if (!this.bar || !this.mainButton) return;
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      this.observer.observe(this.mainButton);
      this.button.disabled = this.mainButton.disabled;
      this.stateObserver = new MutationObserver(()=>{ this.button.disabled = this.mainButton.disabled; });
      this.stateObserver.observe(this.mainButton,{attributes:true,attributeFilter:['disabled']});
      this.button.addEventListener('click',()=>{
        this.form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
        this.mainButton.focus({preventScroll:true});
      },{signal:this.abort.signal});
    }
    update(variant) {
      const unavailable = this.dataset.unavailable;
      const money = variant ? new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(variant.price/100) : unavailable;
      this.querySelectorAll('[data-assist-price]').forEach(node=>node.textContent=money);
      this.querySelectorAll('[data-assist-option]').forEach(node=>node.textContent=variant?.options[Number(node.dataset.assistOption)] || unavailable);
      const sku = this.querySelector('[data-assist-sku]');
      if(sku) { sku.textContent=variant?.sku || ''; this.querySelector('[data-assist-sku-row]').hidden=!variant?.sku; }
      const summary = this.querySelector('[data-assist-summary]');
      if(summary) summary.textContent=variant?.title || unavailable;
      if(this.button) this.button.disabled=!variant?.available;
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.stateObserver?.disconnect(); }
  });
}
